<template>
  <router-view/>
</template>

<style lang="stylus">
#app
  text-align center
  color #2c3e50
</style>
